<template>
  <div class="debugModel clearfix">
    <div class="fl leftCon">
      <h4 class="tal f16 fw" style="margin:10px 0;">选择调试网吧</h4>
      <Form ref="searchForm" :label-width="70" :model="form">
        <FormItem label="添加网吧" class="tal">
          <Select
            v-model="selectBar"
            filterable
            multiple
            @on-query-change="queryChang"
            @on-change="inputKeydown"
          >
            <Option
              v-for="item in barList"
              :value="item.barId"
              :key="item.barId"
              >{{ item.barId }}-{{ item.barName }}-{{
                item.passportName
              }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <h4 class="tal f16 fw" style="margin:20px 0;">调试列表</h4>
      <Tree
        :data="debugList"
        :render="renderContent"
        class="tal"
        @on-select-change="slectBar"
      ></Tree>
    </div>
    <div class="fr rightCon">
      <Tabs
        type="card"
        @on-click="selectTab"
        :value="barId.toString()"
        closable
        @on-tab-remove="handleTabRemove"
        v-if="debugBalist != ''"
      >
        <TabPane
          v-for="(item, index) in debugBalist"
          :key="index"
          :name="item.title.toString()"
          :label="item.title.toString()"
        >
          <barSetCom v-if="curTab == barId" class="tal" :data="item.title" />
        </TabPane>
      </Tabs>
      <div v-else>当前暂无调试网吧</div>
    </div>
  </div>
</template>
<script>
import barSetCom from './barSet'
import { searchBarList, getBarList } from '@/requests/debug'
export default {
  components: {
    barSetCom,
  },
  data() {
    return {
      form: {
        barId: '',
      },
      curTab: '',
      barId: '',
      barData: '',
      barList: [
        // {
        //   barId:100012,
        //   barName:'111'
        // }
      ],
      selectBar: [],
      debugBalist: [],
      data: [
        {
          barName: 'ceshi网吧1',
        },
        {
          barName: 'ceshi网吧2',
        },
      ],
      debugList: [
        {
          title: '调试中',
          expand: true,
          children: [],
        },
        {
          title: '历史调试',
          expand: true,
          children: [],
        },
      ],
      localStorage: '',
    }
  },
  mounted() {
    this.debugBalist = this.debugList[0].children
    this.localStorage = window.localStorage
    if (this.localStorage.getItem('test') != null) {
      this.debugList[1].children = JSON.parse(this.localStorage.getItem('test'))
    }
  },
  methods: {
    queryChang(query) {
      console.log(this.$store.state.user.isDebugAll)
      if (this.$store.state.user.isDebugAll) {
        this.searchBarList(query)
      } else {
        this.getBarList(query)
      }
    },
    async getBarList(query) {
      let res = await getBarList(1, 30, query)
      console.log(res)
      if (res.code == 200) {
        this.barList = res.data.records
      }
    },
    async searchBarList(query) {
      let res = await searchBarList(1, 30, query)
      console.log(res)
      if (res.code == 200) {
        this.barList = res.data.records
      }
    },
    inputKeydown() {
      this.selectBar.forEach((el) => {
        let index = this.debugList[0].children.findIndex(
          (val) => val.title == el
        )
        if (index == -1) {
          this.debugList[0].children.push({
            title: el,
          })
        }
        this.debugList[0].children.forEach((el) => {
          let data = JSON.parse(this.localStorage.getItem('test'))

          if (data != null) {
            if (data.length >= 10) {
              data.pop()
            }
            let index = data.findIndex((val) => val.title == el.title)
            console.log(index)
            if (index == -1) {
              data.unshift(el)
              this.localStorage.setItem('test', JSON.stringify(data))
            }
          } else {
            let data = []
            data.push(el)
            this.localStorage.setItem('test', JSON.stringify(data))
          }
        })
      })
      this.selectBar = []
    },
    selectTab(val) {
      this.curTab = val
      this.barId = val
    },
    renderContent(h, { root, node, data }) {
      return h(
        'span',
        {
          style: {
            display: 'inline-block',
            width: '100%',
          },
        },
        [
          h('i', [h('i', data.title)]),
          h(
            'span',
            {
              style: {
                display: 'inline-block',
                float: 'right',
                marginRight: '8px',
                width: '20px',
              },
            },
            [
              h('Button', {
                props: Object.assign({}, this.buttonProps, {
                  icon: 'ios-remove',
                }),
                style: {
                  fontSize: '12px',
                  width: '20px',
                  height: '20px',
                },
                on: {
                  click: () => {
                    this.remove(root, node, data)
                  },
                },
              }),
            ]
          ),
        ]
      )
    },
    openFn(val) {},
    handleTabRemove(key) {
      let newArr = [...this.debugBalist]
      this.debugBalist = newArr.filter((val) => val.title != key)
    },
    slectBar(val, key) {
      console.log(val == '')
      if (
        val != '' &&
        val[0] != '' &&
        val[0].title != '' &&
        val[0].title != '历史调试' &&
        val[0].title != '调试中'
      ) {
        this.barId = val[0].title
        this.curTab = val[0].title
        let newArr = [...this.debugBalist]
        let index = newArr.findIndex((el) => el.title == this.barId)
        if (index == -1 && this.barId != '历史调试' && this.barId != '调试中') {
          this.debugBalist.push({
            title: this.barId,
          })
        }

        let index2 = this.debugList[0].children.findIndex(
          (el) => el.title == this.barId
        )
        if (
          index2 == -1 &&
          this.barId != '历史调试' &&
          this.barId != '调试中'
        ) {
          this.debugList[0].children.push({
            title: this.barId,
          })
        }
        this.debugList[1].children = this.debugList[1].children.filter(
          (val) => val.title != this.barId
        )
      }
    },
    remove(root, node, data) {
      const parentKey = root.find((el) => el === node).parent
      const parent = root.find((el) => el.nodeKey === parentKey).node
      const index = parent.children.indexOf(data)
      parent.children.splice(index, 1)
      this.debugList[0].children = this.debugList[0].children.filter(
        (val) => val.title != data.title
      )
      let newRrr = [...this.debugBalist]
      this.debugBalist = newRrr.filter((val) => val.title != data.title)
      this.barId = this.debugBalist[this.debugBalist.length - 1].title
      this.curTab = this.debugBalist[this.debugBalist.length - 1].title
    },
  },
}
</script>

<style lang="scss">
.ivu-tree-title {
  width: 100%;
  button {
    display: none;
  }
}
.ivu-tree-children {
  .ivu-tree-children {
    .ivu-tree-title {
      button {
        display: block;
      }
    }
  }
}
.ivu-table-cell {
  padding: 0;
}
</style>
<style lang="scss" scoped>
.debugModel {
  padding: 20px;
  .leftCon {
    padding: 10px;
    width: 260px;
    box-sizing: border-box;
    border: 1px solid #eee;
    border-radius: 10px;
  }
  .rightCon {
    width: calc(100% - 280px);
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 10px;
    box-sizing: border-box;
  }
}
</style>
